module.exports = __webpack_public_path__ + "static/media/car-date.63d66701.svg";